import { render } from "./MimamoriComponent.vue?vue&type=template&id=c4d081ee"
import script from "./MimamoriComponent.vue?vue&type=script&lang=js"
export * from "./MimamoriComponent.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__